<template>
  <div id="main">
    <v-app>
      <v-navigation-drawer class="black hidden-md-and-up" v-show="showNav" clipped app enable-resize-watcher  permanent width="420" style="margin-top:180px;">
        <v-list class="black white--text">
            <v-list-tile>
              <v-list-tile-title style="font-size: 1.2em;" @click="goToUrl('https://www.tynanfinancialsolutions.com.au/')">Home</v-list-tile-title>
            </v-list-tile>
            <v-list-tile>
              <v-list-tile-title style="font-size: 1.2em;" @click="openNewWindow('https://form.jotform.co/81410548458863')">Private Use Application</v-list-tile-title>
            </v-list-tile>
            <v-list-tile>
              <v-list-tile-title style="font-size: 1.2em;" @click="openNewWindow('https://form.jotform.co/81508810258861')">Business Use Application</v-list-tile-title>
            </v-list-tile>
             <v-list-tile>
              <v-list-tile-title style="font-size: 1.2em;" @click="goToUrl('https://www.tynanfinancialsolutions.com.au/contact')">Contact</v-list-tile-title>
            </v-list-tile>
        </v-list>
  </v-navigation-drawer>
    <div style="position:fixed; left:30px; top:120px; z-index:300" class="headline white--text hidden-md-and-up"><v-btn icon color="white"><v-icon color="black">phone</v-icon></v-btn>02 8545 8888</div>
    <v-toolbar clipped-left fixed app style="height:160px;" class="black">
    <v-container  style="margin:0 auto; width=100%" class="maxPageWidth">
      <v-layout row wrap align-end style="height:150px;">
    <v-flex xs11 sm7 md6 class="white--text text-xs-left">
      <a href="https://www.tynanfinancialsolutions.com.au/"><img src="@/assets/tynan_logo.webp" :class="{smallLogo:$vuetify.breakpoint.smAndDown}"></a><div class="subheading font-weight-thin" :class="{smallText:$vuetify.breakpoint.smAndDown}">Finance Solutions.Tailored to your needs.</div>
    </v-flex>
    
    <v-flex xs1 sm5 class="hidden-md-and-up white--text text-xs-right" style="margin-bottom:40px;" @click="showNav=!showNav"><v-icon class="white--text text-xs-right">menu</v-icon></v-flex>
    <v-flex xs12 sm5 md6 class="white--text text-xs-right" style="margin-bottom:-13px;" v-show="$vuetify.breakpoint.mdAndUp">
       <div class="headline white--text hidden-sm-and-down"><v-btn icon color="white"><v-icon color="black">phone</v-icon></v-btn>02 8545 8888</div>

        <v-btn flat class="heading white--text" style="text-transform: none !important; font-size: 1.2em;" @click="goToUrl('https://www.tynanfinancialsolutions.com.au/')">Home</v-btn>
       <v-menu offset-y>
         <v-btn slot="activator" dark flat class="heading white--text" style="text-transform: none !important; font-size: 1.2em;">Apply Now!<v-icon dark>arrow_drop_down</v-icon></v-btn>
          <v-list dark>
            <v-list-tile>
              <v-list-tile-title @click="openNewWindow('https://form.jotform.co/81410548458863')">Private Use Application</v-list-tile-title>
            </v-list-tile>
            <v-list-tile>
              <v-list-tile-title @click="openNewWindow('https://form.jotform.co/81508810258861')">Business Use Application</v-list-tile-title>
            </v-list-tile>
          </v-list>
        </v-menu>
      <v-btn flat class="heading white--text" style="text-transform: none !important; font-size: 1.2em;" @click="goToUrl('https://www.tynanfinancialsolutions.com.au/contact')">Contact</v-btn>
    </v-flex>
    </v-layout>
    </v-container>
  </v-toolbar>
  <div style="margin-top:160px;">
  
      <!-- error states -->
      <div class v-if="!isValidBrowser || cantGetRates">
        <v-container v-if="!isValidBrowser">
          <h1>Your browser is not compatible</h1>
          <h2>Please update your browser to either Chrome, Firefox, Microsoft Edge, Internet Explorer 11 or Safari 9+ in order
            to use this car loan calculator.</h2>
        </v-container>
        <v-container v-if="cantGetRates">
          <h1>Calculator temporarily unavailable</h1>
          <h2>Error: car loan calculator is temporarily unavailable</h2>
        </v-container>
      </div>
      <!-- end of error states -->

      <div v-else>
        <v-container v-if="pageLoading" fluid align-content-center justify-center fill-height style="height:100vh">

          <v-flex xs12>
            <v-progress-circular indeterminate color="primary"></v-progress-circular>
            <br>
            <br>
            <div class="subheading">Car loan calculator loading...</div>
          </v-flex>
        </v-container>
        
        <v-container class="grid-list-md text-xs-left white--text maxPageWidth" v-else>
          <v-layout row wrap> 
            <v-flex xs12 md6>
              <loan-details v-model="loan"></loan-details>
            </v-flex>
            <v-flex xs12 md6 fill-height>
              <results v-model="results" :loan="loan" :privateVars="privateRates" :businessVars="businessRates" @email="showEmail()" @enquiry="showEnquiry()" @apply="apply()"></results>
              <v-spacer></v-spacer>
              <contact-form v-model="contactForm" :displayLoader="contactFormLoader" :sendEnquiry="sendEnquiry" @send="sendQuote()" v-if="showForm"></contact-form>

              <info-box v-if="successDialog && sendEnquiry==true">Thank you very much for your enquiry. Our team will contact you shortly.
              </info-box>
              <info-box v-if="successDialog && sendEnquiry==false">You should be receiving a quote for the loan enquiry shortly.</info-box>
              <info-box v-if="failDialog">There was an error submitting your form details.</info-box>
            </v-flex>
          </v-layout>
          <v-flex xs12>
            <info-pane :data="infoPaneData"></info-pane>
          </v-flex>
            <v-footer class="pa-3 black white--text subheading" style="height:200px;">
              <div style="max-width:300px;display:flex;"> 1 - 11 Kumulla Road,<br>
                 Miranda, NSW, 2228<br><br><br></div>
              <v-spacer></v-spacer>
              <div style="max-width:300px;display:flex">P. 02 8545 8888<br>
                E. finance@tynan.com.au<br><br><br></div>
            </v-footer>
        </v-container>
      </div>
      </div>
    </v-app>
  </div>
</template>

<script>
  import LoanDetails from "./LoanDetails.vue";
  import Results from "./Results.vue";
  import ContactForm from "./ContactForm.vue";
  import InfoPane from "./InfoPane.vue";
  import InfoBox from "./InfoBox.vue";

  export default {
    name: "Main",
    props: {
      msg: String
    },
    components: {
      LoanDetails,
      Results,
      ContactForm,
      InfoPane,
      InfoBox
    },
    $_veeValidate: {
      validator: "new"
    },

    mounted() {
      this.isValidBrowser = this.browserCheck();
      this.$http
        .get(this.$apiURL + "/rates")
        .then(res => {
          this.privateRates=res.data.private;
          this.businessRates=res.data.business;
          this.whatever=true;
          this.pageLoading = false;

          //website may pass in string values to calculator page via a query string. ?amount=2000&term=48
          //amount in dollars and interest in months. Set these values in the calculator. 
          if (this.$route.query.amount){
          this.loan.amount=this.$route.query.amount
          }

          if(this.$route.query.term){
            this.loan.term=Number(this.$route.query.term);
          }
          //console.log("this is data in privateRates ", JSON.stringify(this.privateRates))
        })
        .catch(err => {
          console.log(err);
          this.cantGetRates = true;
        });
    },
    //to pass validator in to child component
    provide() {
      return {
        parentValidator: this.$validator
      };
    },
    data() {
      return {
        showNav:false,
        buttonValues: Object.assign({}, this.$buttonValues),
        privateRates: {
          baseRate: 6.35,
          margin: 2,
          lessThan10k: 1,
          longerThan5Years: 1,
          financierFees: 0,
          dealerFees: 0,
          monthlyFee: 0,
          residency: 1,
          creditRating: 0,
          carType: 0
        },
        businessRates: {
          baseRate: 6.35,
          margin: 2,
          lessThan10k: 1,
          longerThan5Years: 1,
          financierFees: 0,
          dealerFees: 0,
          monthlyFee: 0,
          residency: 1,
          creditRating: 0,
          carType: 0
        },
        contactForm: {},
        results: {
          interestRate: 0,
          comparisonRate: 0,
          weeklyPayment: 0,
          balloonPayment: 0
        },
        test: "",
        pageLoading: true,
        contactFormLoader: false,
        cantGetRates: false,
        version: 0, //browser version
        isValidBrowser: false,
        successDialog: false,
        failDialog: false,
        sendEnquiry: false,
        showForm: false,
        loan: {
          amount: 30000,
          term: 60,
          carUse: this.$buttonValues.PRIVATE,
          residency: this.$buttonValues.OWNER,
          creditRating: this.$buttonValues.GOOD,
          carType: this.$buttonValues.NEW
        }

      };
    },
    methods: {
      openNewWindow(url){
        window.open(url, '_blank');
      },
      goToUrl(url){
        window.location.href = url; 
      },
      browserCheck() {
        this.version = bowser.version;
        if (bowser.chrome || bowser.firefox || bowser.edge) {
          return true;
        }
        if (bowser.safari && bowser.version >= 9) {
          return true;
        } else if (bowser.msie && bowser.version >= 11) {
          return true;
        }

        return false;
      },

      showEnquiry() {
        this.sendEnquiry = true;
        this.showForm = true;
        //reset dialogs;
        this.successDialog = false;
        this.failDialog = false;
      },
      showEmail() {
        this.sendEnquiry = false;
        this.showForm = true;

        this.successDialog = false;
        this.failDialog = false;
      },
      apply(){
        if (this.loan.carUse == this.buttonValues.PRIVATE){
          window.open('https://form.jotform.co/81410548458863', '_blank');
        } else {
          window.open('https://form.jotform.co/81508810258861', '_blank');
        }
      },
      sendQuote() {
        this.contactFormLoader = true;
        this.$validator.validateAll().then(result => {
          if (result) {
            var data = {
              firstName: this.contactForm.firstName,
              lastName: this.contactForm.lastName,
              email: this.contactForm.email,
              phone: "\'" + this.contactForm.phone, //convert to google sheet string to enable the 0 to be displayed
              loanAmount: this.loan.amount,
              loanTerm: this.loan.term,
              carUse: this.loan.carUse,
              creditRating: this.loan.creditRating,
              carType: this.loan.carType,
              residency: this.loan.residency,
              interestRate: this.results.interestRate,
              weeklyPayment: this.results.weeklyPayment,
              balloonPayment: this.results.balloonPayment,
              comparisonRate: this.results.comparisonRate,
              enquiryOrEmail: this.sendEnquiry ? "Enquiry" : "Email"
            };

            this.$http
              .post(
                this.$apiURL + "/quote", {
                  data: data
                }, {
                  headers: {
                    "Content-Type": "application/json"
                  }
                }
              )
              .then(res => {
                return this.sendEnquiry ?
                  this.$http.post(
                    this.$apiURL + "/enquiry", {
                      data: data
                    }, {
                      headers: {
                        "Content-Type": "application/json"
                      }
                    }
                  ) :
                  null;
              })
              .then(() => {
                return this.$http.post(
                  this.$apiURL + "/note", {
                    data: data
                  }, {
                    headers: {
                      "Content-Type": "application/json"
                    }
                  }
                );
              })
              .then(() => {
                this.successDialog = true;
                this.showForm = false;
                this.contactFormLoader = false;
              })
              .catch(err => {
                console.log(err);
                this.contactFormLoader = false;
                this.failDialog = true;
              });
          } else {
            this.contactFormLoader = false;
          }
        });
      },
      testComparisonRate() {
        return this.rate(6, -4227.64, 25000) * 12;
        //these figures in the rate function in excel return a value of 0.05 or 5%.
      },

      testPMT() {
        //return this.PMT(6, -4227.64,25000)*12;
        return this.pmt(5 / 1200, 6, 25000);

        //these figures in the PMT function in excel return a value of -4227.64;
      },

    },

    computed: {
      infoPaneData: function () {
        return [{
            heading: "Important Information",
            text: "The results from this calculator should be used as an indicative guide only and it is not a formal quote or an offer of finance. The weekly repayments and suggested interest rates do not take into account your personal or financial circumstances, and all applications are subject to the normal credit approval criteria of our bank and finance partners. Our goal is to always source the best possible available packages based on your unique circumstances so please contact us with any special needs or preferences that you have. The weekly repayment amount is based on a finance amount of $" +
              this.loan.amount + " on a secured Consumer Loan with a " + 
              this.loan.term + " month term and " + 
              this.results.interestRate + "% p.a. interest rate. The monthly equivalent repayment is $" 
              + (this.results.weeklyPayment * 52 / 12).toFixed(2) +
              ". Repayments must be made monthly and cannot be made weekly. Dealer commission, standard fees and charges apply. The comparison interest rate is " +
              this.results.comparisonRate +
              "% p.a. and is based on a finance amountof $30,000 on a secured Consumer Loan for a 60 month term. WARNING: This comparison rate is true only for the examples given and may not include all fees and charges. Different terms, fees or other loan amounts might result in a different comparison rate. Finance offer only available at Tynan Financial Solutions at the discretion of the financier. The comparison rate is based on current statutory, establishment, and monthly account fees applied to loans provided by Macquarie Leasing Pty Limited ABN 38 002 674 982 (Australian Credit Licence No. 394925) to approved applicants, subject to its credit assessment criteria. Fees and charges are payable. Full conditions available on application."

          },
          /*{
            heading: "Terms & Conditions",
            text: "boo"
          },*/
          {
            heading: "Privacy Policy",
            text:
            `
<span>PRIVACY POLICIES OF TYNAN FINANCIAL SOLUTIONS AND TYNAN MOTORS PTY LTD</span><br>
<span>Privacy Policy of Tynan Financial Solutions</span>
<p>&nbsp;</p>
<ul>
<li>
<span>We respect your privacy</span>
</li>
</ul>
<p>&nbsp;</p>
<ol>
<ol>
<li><span>Tynan Financial Solutions respects your right to privacy and is committed to safeguarding the privacy of our customers and website visitors. We adhere to the Australian Privacy Principles contained in the </span><em><span>Privacy Act</span></em><span> 1988 (Cth). This policy sets out how we collect and treat your personal information.</span></li>
<li><span>"Personal information" is information we hold which is identifiable as being about you.</span></li>
</ol>
</ol>
<p>&nbsp;</p>
<ul>
<li>
<span>Collection of personal information</span>
</li>
</ul>
<p>&nbsp;</p>
<ol>
<ol>
<li><span>Tynan Financial Solutions will, from time to time, receive and store personal information you enter onto our website, provided to us directly or given to us in other forms.</span></li>
<li><span>You may provide basic information such as your name, phone number, address and email address to enable us to send information, provide updates and process your product or service order. We may collect additional information at other times, including but not limited to, when you provide feedback, when you provide information about your personal or business affairs, change your content or email preference, respond to surveys and/or promotions, provide financial or credit card information, or communicate with our customer support.</span></li>
<li><span>Additionally, we may also collect any other information you provide while interacting with us.</span></li>
</ol>
</ol>
<p>&nbsp;</p>
<ul>
<li>
<span>How we collect your personal information</span>
</li>
</ul>
<p>&nbsp;</p>
<ol>
<ol>
<li><span>Tynan Financial Solutions collects personal information from you in a variety of ways, including when you interact with us electronically or in person, when you access our website and when we provide our services to you. We may receive personal information from third parties. If we do, we will protect it as set out in this Privacy Policy.</span></li>
</ol>
</ol>
<p>&nbsp;</p>
<ul>
<li>
<span>Use of your personal information</span>
</li>
</ul>
<p>&nbsp;</p>
<ol>
<ol>
<li><span>Tynan Financial Solutions may use personal information collected from you to provide you with information, updates and our services. We may also make you aware of new and additional products, services and opportunities available to you. We may use your personal information to improve our products and services and better understand your needs.</span></li>
<li><span>Tynan Financial Solutions may contact you by a variety of measures including, but not limited to telephone, email, sms or mail.</span></li>
</ol>
</ol>
<p>&nbsp;</p>
<ul>
<li>
<span>Disclosure of your personal information</span>
</li>
</ul>
<p>&nbsp;</p>
<ol>
<ol>
<li><span>We may disclose your personal information to any of our employees, officers, insurers, professional advisers, agents, suppliers or subcontractors insofar as reasonably necessary for the purposes set out in this Policy. Personal information is only supplied to a third party when it is required for the delivery of our services.</span></li>
<li><span>We may from time to time need to disclose personal information to comply with a legal requirement, such as a law, regulation, court order, subpoena, warrant, in the course of a legal proceeding or in response to a law enforcement agency request.</span></li>
<li><span>We may also use your personal information to protect the copyright, trademarks, legal rights, property or safety of Tynan Financial Solutions, www.tynanFinancialsolutions.com.au, its customers or third parties.</span></li>
<li><span>Information that we collect may from time to time be stored, processed in or transferred between parties located in countries outside of Australia. </span></li>
<li><span>If there is a change of control in our business or a sale or transfer of business assets, we reserve the right to transfer to the extent permissible at law our user databases, together with any personal information and non-personal information contained in those databases. This information may be disclosed to a potential purchaser under an agreement to maintain confidentiality. We would seek to only disclose information in good faith and where required by any of the above circumstances.</span></li>
<li><span>By providing us with personal information, you consent to the terms of this Privacy Policy and the types of disclosure covered by this Policy. Where we disclose your personal information to third parties, we will request that the third party follow this Policy regarding handling your personal information.</span></li>
</ol>
</ol>
<p>&nbsp;</p>
<ul>
<li>
<span>Security of your personal information</span>
</li>
</ul>
<p>&nbsp;</p>
<ol>
<ol>
<li><span>Tynan Financial Solutions is committed to ensuring that the information you provide to us is secure. In order to prevent unauthorised access or disclosure, we have put in place suitable physical, electronic and managerial procedures to safeguard and secure information and protect it from misuse, interference, loss and unauthorised access, modification and disclosure.</span></li>
<li><span>The transmission and exchange of information is carried out at your own risk. We cannot guarantee the security of any information that you transmit to us, or receive from us. Although we take measures to safeguard against unauthorised disclosures of information, we cannot assure you that personal information that we collect will not be disclosed in a manner that is inconsistent with this Privacy Policy.</span></li>
</ol>
</ol>
<p>&nbsp;</p>
<ul>
<li>
<span>Access to your personal information</span>
</li>
</ul>
<p>&nbsp;</p>
<ol>
<ol>
<li><span>You may request details of personal information that we hold about you in accordance with the provisions of the </span><em><span>Privacy Act</span></em><span> 1988 (Cth). A small administrative fee may be payable for the provision of information. If you would like a copy of the information, which we hold about you or believe that any information we hold on you is inaccurate, out of date, incomplete, irrelevant or misleading, please email us at Financial@tynan.com.au.</span></li>
<li><span>We reserve the right to refuse to provide you with information that we hold about you, in certain circumstances set out in the Privacy Act.</span></li>
</ol>
</ol>
<p>&nbsp;</p>
<ul>
<li>
<span>Complaints about privacy</span>
</li>
</ul>
<p>&nbsp;</p>
<ol>
<ol>
<li><span>If you have any complaints about our privacy practices, please feel free to send in details of your complaints to General Manager, Tynan Financial Solutions, 642 Old Princes Hwy, SUTHERLAND, New South Wales, 2232. We take complaints very seriously and will respond shortly after receiving written notice of your complaint.</span></li>
</ol>
</ol>
<p>&nbsp;</p>
<ul>
<li>
<span>Changes to Privacy Policy</span>
</li>
</ul>
<p>&nbsp;</p>
<ol>
<ol>
<li><span>Please be aware that we may change this Privacy Policy in the future. We may modify this Policy at any time, in our sole discretion and all modifications will be effective immediately upon our posting of the modifications on our website or notice board. Please check back from time to time to review our Privacy Policy.</span></li>
</ol>
</ol>
<p>&nbsp;</p>
<ul>
<li>
<span>Website</span>
</li>
</ul>
<p>&nbsp;</p>
<ol>
<ol>
<li><em><span>When you visit our website</span></em></li>
</ol>
</ol>
<ul>
<ul>
<li><span>When you come to our website (www.tynanFinancialsolutions.com.au) we may collect certain information such as browser type, operating system, website visited immediately before coming to our site, etc. This information is used in an aggregated manner to analyse how people use our site, such that we can improve our service.</span></li>
</ul>
</ul>
<ol>
<ol>
<li><em><span>Cookies</span></em></li>
</ol>
</ol>
<ul>
<ul>
<li><span>We may from time to time use cookies on our website. Cookies are very small files which a website uses to identify you when you come back to the site and to store details about your use of the site. Cookies are not malicious programs that access or damage your computer. Most web browsers automatically accept cookies but you can choose to reject cookies by changing your browser settings. However, this may prevent you from taking full advantage of our website. Our website may from time to time use cookies to analyses website traffic and help us provide a better website visitor experience. In addition, cookies may be used to serve relevant ads to website visitors through third party services such as Google Adwords. These ads may appear on this website or other websites you visit.</span></li>
</ul>
</ul>
<ol>
<ol>
<li><em><span>Third party sites</span></em></li>
</ol>
</ol>
<ul>
<ul>
<li><span>Our site may from time to time have links to other websites not owned or controlled by us. These links are meant for your convenience only. Links to third party websites do not constitute sponsorship or endorsement or approval of these websites. Please be aware that Tynan Financial Solutions is not responsible for the privacy practises of other such websites. We encourage our users to be aware, when they leave our website, to read the privacy statements of each and every website that collects personal identifiable information.</span></li>
</ul>
</ul>
<p><span>1st July 2018</span></p>
<p>&nbsp;</p>
<p><span>Privacy Policy of Tynan Motors Pty Ltd</span></p>
<p>&nbsp;</p>
<p><span>Tynan Motors Pty Ltd (Tynan Motors) respects privacy and personal information. Where Tynan Motors deals with your personal information, being an Australian company Tynan Motors is governed by and complies with, the National Privacy Principles which are found in the Privacy Act 2014 (as amended from time to time).</span></p>
<p><span>Information Collection and Use</span></p>
<p><span>Tynan Motors collects personal information on this web site for purposes that are made clear on the page on which the information is collected, such as when you request to be sent information.</span></p>
<p><span>Tynan Motors collects and uses your information to provide information relating to our products and services that is relevant to your interests.</span></p>
<p><span>Tynan Motors does not collect and process any personal information unless the information is considered necessary for the effective functioning or activities of our business.</span></p>
<p><span>Generally, Tynan Motors only processes personal information for the purposes for which it was originally collected, unless required or authorised by or under law or if the individual concerned has consented to the intended use. Tynan Motors destroys or permanently de-identifies personal information that is no longer needed.</span></p>
<p><span>Tynan Motors does not collect and/or process any personal or sensitive information against the expressed wishes of an individual, unless Tynan Motors &nbsp;&nbsp;is required by law to do so.</span></p>
<p><span>You have the right to remain anonymous when entering into transactions with Tynan Motors, unless such anonymity would be considered unlawful or impracticable.</span></p>
<p><span>Tynan Motors does not use or pass onto others any personal information without the consent of the individual(s) concerned unless required by law. Nevertheless, Tynan Motors third party service providers may occasionally have access to the personal information held by Tynan Motors &nbsp;&nbsp;under conditions of confidentiality.</span></p>
<p><span>Tynan Motors takes steps to ensure that personal information is kept safe from misuse, loss and unauthorised access, modification and disclosure.</span></p>
<p><span>Tynan Motors will not transfer personal information to a foreign country unless such a transfer is allowed by law.</span></p>
<p><span>Other Information Uses and Disclosure</span></p>
<p><span>Tynan Motors &nbsp;may use information relating to your visit to our website, or information you provide to us, for market research purposes in order to continually improve the product and service that Tynan Motors &nbsp;&nbsp;delivers to you.</span></p>
<p><span>On occasions, Tynan Motors may form relationships with other organisations, designed to bring you special offers or competitions, relevant to your preferences. Tynan Motors &nbsp;&nbsp;only deals with parties that demonstrate the same level of commitment to your privacy as Tynan Motors does, and can assure complete compliance with all Australian privacy laws.</span></p>
<p><span>In the unlikely event that Tynan Motors sells a part or whole of its business, its records of personal information may be transferred to the new business owner. The information will remain subject to privacy law and until further notified, will remain subject to Tynan Motors&rsquo; privacy policy. If at any stage you are receiving communications from Tynan Motors and you do not wish to receive any further communications, please let us know.</span></p>
<p><span>Cookies</span></p>
<p><span>The Tynan&nbsp;website uses cookies, tracking pixels and related technologies. Cookies are small data files that are served by our platform and stored on your device. Our site uses cookies dropped by us or third parties for a variety of purposes including to operate and personalize the website. Also, cookies may also be used to track how you use the site to target ads to you on other websites.</span></p>
<p><span>Further questions:</span></p>
<p><span>At all times, Tynan Motors strives to ensure your personal information is treated confidentially, and in accordance with the Privacy Act. If you believe your personal information has been handled in a way that does not comply with the Privacy Act 2014, or if you wish to access information that Tynan Motors &nbsp;&nbsp;holds about you, please contact us. For security reasons, we require that requests for personal information are provided in writing. Tynan Motors will endeavour to provide you with this access unless Tynan Motors is required or authorised to refuse such access by the laws of Australia. All such enquiries should be directed to does not collect and/or process any personal or sensitive information against the expressed wishes of an individual, unless Tynan Motors is required by law to do so.</span></p>
<p><span>At all times, Tynan Motors &nbsp;&nbsp;strives to ensure your personal information is treated confidentially, and in accordance with the Privacy Act 2014 (Cth). If you believe your personal information has been handled in a way that does not comply with the Privacy Act 2014 (Cth), or if you wish to access information that Tynan Motors &nbsp;&nbsp;holds about you, please contact us. For security reasons, we require that requests for personal information are provided in writing. Tynan Motors will endeavour to provide you with this access unless Tynan Motors is required or authorised to refuse such access by the laws of Australia. All such enquiries should be directed to Data Protection Officer. Email enquiry form is on www.tynan.com.au</span></p>
<p><br><br></p>
     `
     }]
      }
    }
  };
</script>

<!-- Add "scoped" attribute to limit CSS to this component only -->
<style>

.maxPageWidth {
  max-width:975px;
  width:100%;
}
  .hmargin {
    margin-left:15% !important;
  }
  .hmarginright {
    margin-right:15% !important;
  }

.smallLogo {
  width:210px;
}
.smallText {
  font-size:0.9em !important;
}

  
  .box {
    background-color: #212121 !important;
    color: white !important;
  }

  .buttonToggleStretch {
    width: 100%;
    color: green;
    margin: 5px 0px;
  }
</style>